import { TableHeadersType } from "./tableHeadersType";

export const AVERAGE_JOB_RATING_HEADERS: TableHeadersType[] = [
    {
      label: "JOB NAME",
      value: "job_type",
      defaultChecked: true,
      checked: true,
    },
    {
      label: "CLIENT NAME",
      value: "company_name",
      defaultChecked: true,
      checked: true,
    },
    {
      label: "JOB DESCRIPTION",
      value: "job_description",
      defaultChecked: true,
      checked: true,
    },
   
    {
      label: "JOB MANAGER",
      value: "job_manager",
      defaultChecked: true,
      checked: true,
    },
    {
        label: "JOB STATUS",
        value: "job_status",
        defaultChecked: true,
        checked: true,
      },
      {
        label: "RATING",
        value: "rating",
        defaultChecked: true,
        checked: true,
      },
      {
        label: "COMMENT",
        value: "comment",
        defaultChecked: true,
        checked: true,
      },
  ];